var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgImgEmptySearchCustomer = function SvgImgEmptySearchCustomer(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h80v80H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    stroke: "#BDBDBD",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    transform: "translate(4.444 22.222)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.066 15.625h5.868a6.72 6.72 0 0 1 6.703 6.25l.363 5.18a1 1 0 0 1-.997 1.07H.997A1 1 0 0 1 0 27.055l.363-5.18a6.72 6.72 0 0 1 6.703-6.25zM5 23.75l.715 3.681m9.166-3.681-.715 3.681"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 6.875,
    r: 6.875
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    stroke: "#BDBDBD",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    transform: "translate(17.778 42.222)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.066 15.625h5.868a6.72 6.72 0 0 1 6.703 6.25l.363 5.18a1 1 0 0 1-.997 1.07H.997A1 1 0 0 1 0 27.055l.363-5.18a6.72 6.72 0 0 1 6.703-6.25zM5 23.75l.715 3.681m9.166-3.681-.715 3.681"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 6.875,
    r: 6.875
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#BDBDBD",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.3,
    stroke: "#BDBDBD",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M31.444 12.222h37a6 6 0 0 1 6 6v1.334a6 6 0 0 1-6 6h-43v-7.334a6 6 0 0 1 6-6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.785 17.779c.292-.008.575.098.784.294a1 1 0 0 1 .32.742v.15c-.013.575-.507 1.035-1.111 1.035-.605 0-1.098-.46-1.111-1.035v-.15c-.003-.28.114-.55.326-.746.21-.196.497-.301.792-.29zm5.555 0a1.1 1.1 0 0 1 .784.294 1 1 0 0 1 .32.742v.15c-.013.575-.506 1.035-1.11 1.035-.605 0-1.099-.46-1.112-1.035v-.15c-.003-.28.115-.55.326-.746.211-.196.498-.301.792-.29zm5.556 0c.292-.008.575.098.784.294a1 1 0 0 1 .32.742v.15c-.013.575-.507 1.035-1.111 1.035s-1.098-.46-1.111-1.035v-.15c-.003-.28.114-.55.326-.746.211-.196.497-.301.792-.29zm8.889 0c.292-.008.575.098.784.294a1 1 0 0 1 .32.742v.15c-.013.575-.507 1.035-1.111 1.035-.605 0-1.098-.46-1.111-1.035v-.15c-.003-.28.114-.55.326-.746.21-.196.497-.301.792-.29zm5.555 0a1.1 1.1 0 0 1 .784.294 1 1 0 0 1 .32.742v.15c-.013.575-.506 1.035-1.11 1.035-.605 0-1.099-.46-1.112-1.035v-.15c-.003-.28.115-.55.326-.746.211-.196.498-.301.792-.29z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#BDBDBD",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.3,
    stroke: "#BDBDBD",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M44.778 33.333h25.424a6 6 0 0 1 6 6v1.334a6 6 0 0 1-6 6H38.778v-7.334a6 6 0 0 1 6-6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.118 38.89a1.1 1.1 0 0 1 .784.294 1 1 0 0 1 .32.742v.15c-.013.575-.507 1.035-1.11 1.035-.605 0-1.099-.46-1.112-1.035v-.15c-.003-.28.115-.55.326-.746.211-.196.498-.301.792-.29zm5.556 0c.292-.008.575.098.783.294a1 1 0 0 1 .32.742v.15c-.013.575-.506 1.035-1.11 1.035-.605 0-1.098-.46-1.111-1.035v-.15a1 1 0 0 1 .325-.746c.212-.196.498-.301.793-.29zm5.556 0c.292-.008.575.098.783.294a1 1 0 0 1 .32.742v.15c-.013.575-.506 1.035-1.11 1.035-.605 0-1.099-.46-1.112-1.035v-.15c-.003-.28.115-.55.326-.746.211-.196.498-.301.792-.29z"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgImgEmptySearchCustomer);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/img-empty-search-customer.ec7cc1eb684fd03fd30fcd9a021bd1fa.svg";